import React, { FormEvent } from 'react';
import { Button, TextField, styled } from '@mui/material';
import { Search } from '@mui/icons-material';
import { ProductQueryParams } from './hooks/useFetchProducts';
import FilterBox from 'components/filter-box/FilterBox';

const Filter = styled('form')(({ theme }) => ({
  display: 'grid',
  alignItems: 'center',
  gridTemplateColumns: '300px 200px 100px',
  columnGap: 10,
  rowGap: 15,
  [theme.breakpoints.down('md')]: {
    gridTemplateColumns: '1fr 1fr 100px',
  },
  [theme.breakpoints.down('sm')]: {
    gridTemplateColumns: '1fr',
  },
}));

type ProductFilterBoxProps = {
  filter: ProductQueryParams;
  handleChange<K extends keyof ProductQueryParams>(index: K, value: ProductQueryParams[K]): void;
  handleSearch(e?: FormEvent<HTMLFormElement>): void;
  loading: boolean;
};

const ProductFilterBox: React.FC<ProductFilterBoxProps> = ({ filter, loading, handleChange, handleSearch }) => {
  return (
    <FilterBox>
      <Filter onSubmit={handleSearch}>
        <TextField
          fullWidth
          label="Nome"
          placeholder="Digite o nome do produto"
          value={filter.name}
          autoFocus
          onChange={e => handleChange('name', e.target.value)}
        />

        <TextField
          fullWidth
          label="Fabricante"
          placeholder="Digite o fabricante do produto"
          value={filter.manufacturer}
          onChange={e => handleChange('manufacturer', e.target.value)}
        />

        <Button
          type="submit"
          disabled={loading}
          variant="contained"
          color="primary"
          size="small"
          startIcon={<Search />}
        >
          Buscar
        </Button>
      </Filter>
    </FilterBox>
  );
};

export default ProductFilterBox;
